import { render, staticRenderFns } from "./CustomAlert.vue?vue&type=template&id=cb4ef74e&scoped=true&"
import script from "./CustomAlert.vue?vue&type=script&lang=js&"
export * from "./CustomAlert.vue?vue&type=script&lang=js&"
import style0 from "./CustomAlert.vue?vue&type=style&index=0&id=cb4ef74e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb4ef74e",
  null
  
)

export default component.exports